import { render, staticRenderFns } from "./HomeLight.vue?vue&type=template&id=431b577f&scoped=true"
import script from "./HomeLight.vue?vue&type=script&lang=js"
export * from "./HomeLight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431b577f",
  null
  
)

export default component.exports